export default __webpack_public_path__ + "static/media/panton-regular-webfont.b4c3aa34.woff2";